import React from 'react';
import TenantModuleGate from './TenantModuleGate';

interface ServicioModuleGateProps {
  children: React.ReactNode;
}

const ServicioModuleGate: React.FC<ServicioModuleGateProps> = ({ children }) => (
  <TenantModuleGate moduleKey="servicio">{children}</TenantModuleGate>
);

export default ServicioModuleGate;
